import { create } from 'zustand';
import { WatchlistDataType, WatchlistType } from 'typings/marketWatch.type';
import {
  deleteWatchListAction,
  getUserBasketListAction,
  getMarketWatchInitialDataAction,
  getClientWatchlistAction,
  patchWatchListAction,
  postNewWatchListAction,
  setPreferencesAction,
  postWatchListAction,
} from './action';
import { OptionType } from 'typings/common.type';

export type PreferencesType = {
  industries: string[];
  showOpenSymbols: boolean;
  groupByIndustry: boolean;
};
type SpecialPackagesType = {
  marketWatchInitialData: WatchlistDataType;
  marketWatchInitialDataLoading: boolean;
  marketWatchInitialDataError: boolean;
  getMarketWatchInitialDataAction: (status?: boolean) => void;
  marketWatchSearchOptions: OptionType[];
  marketWatchPreferences: PreferencesType;
  setPreferencesAction: (body: PreferencesType) => Promise<void>;
  postNewWatchListAction: (body: { watchName: string }) => Promise<void>;
  deleteWatchListAction: (id: number) => Promise<void>;
  setCurrentWatchlistIdAction: (id: number) => void;
  patchWatchListAction: (id: number, name: string) => void;
  postWatchListAction: (id: number, newList: string[]) => Promise<boolean>;
  getUserBasketListAction: (id?: number) => void;
  userBasketList: WatchlistType[];
  userBasketLoading: boolean;
  userBasketError: boolean;
  currentWatchlistId: number;
  addNewWatchListLoading: boolean;
  deleteWatchListLoading: boolean;
  editWatchListNameLoading: boolean;
  getClientWatchlistAction: (id: number, notShowLoading?: boolean) => void;
  clientWatchlistData: WatchlistDataType;
  clientWatchlistLoading: boolean;
  clientWatchlistError: boolean;
  updateWatchListLoading: boolean;
  updateWatchListError: boolean;
  changeSocketConnectionAction: (status: boolean) => void;
  socketConnectionReopen: boolean;
  reset: () => void;
};

const initialState = {
  marketWatchInitialData: null,
  marketWatchInitialDataLoading: false,
  marketWatchInitialDataError: false,
  marketWatchSearchOptions: null,
  marketWatchPreferences: {
    industries: null,
    showOpenSymbols: false,
    groupByIndustry: false,
  },
  userBasketList: null,
  userBasketLoading: false,
  userBasketError: false,
  currentWatchlistId: null,
  addNewWatchListLoading: false,
  deleteWatchListLoading: false,
  editWatchListNameLoading: false,
  clientWatchlistData: null,
  clientWatchlistLoading: false,
  clientWatchlistError: false,
  updateWatchListLoading: false,
  updateWatchListError: false,
  socketConnectionReopen: false,
};

const useMarketWatchStore = create<SpecialPackagesType>((set) => ({
  ...initialState,
  reset: (): void => set(initialState),
  getMarketWatchInitialDataAction: (notShowLoading?): Promise<void> =>
    getMarketWatchInitialDataAction(set, notShowLoading),
  setPreferencesAction: (body: PreferencesType): Promise<void> =>
    setPreferencesAction(set, body),
  getUserBasketListAction: (): Promise<void> => getUserBasketListAction(set),
  postNewWatchListAction: (body): Promise<void> =>
    postNewWatchListAction(set, body),
  deleteWatchListAction: (id): Promise<void> => deleteWatchListAction(set, id),
  getClientWatchlistAction: (id, notShowLoading): Promise<void> =>
    getClientWatchlistAction(set, id, notShowLoading),
  patchWatchListAction: (id, name): Promise<void> =>
    patchWatchListAction(set, id, name),
  setCurrentWatchlistIdAction: (id): void => set({ currentWatchlistId: id }),
  postWatchListAction: (id, newList): Promise<boolean> =>
    postWatchListAction(set, id, newList),
  changeSocketConnectionAction: (status): void =>
    set({ socketConnectionReopen: status }),
}));

export default useMarketWatchStore;
